import { FC, useCallback } from "react";
import { useAppDispatch } from "@/store/hooks";
import { ResourceExplorerChartScale } from "@/store/resource-explorer/utils/types/billingExplorer";
import { setResourceExplorerChartBase } from "@/store/resource-explorer/resourceExplorerSlice";
import { ChartScaleSelect } from "@/storybook/c8r-highcharts/common/components/ChartScaleSelect";
import { updateBillingExplorerChartSettingsThunk } from "@/store/resource-explorer/thunks/resource-explorer/updateBillingExplorerChartSettingsThunk";

interface BillingExplorerChartScaleSelectProps {
  scale: ResourceExplorerChartScale;
}

export const BillingExplorerChartScaleSelect: FC<
  BillingExplorerChartScaleSelectProps
> = ({ scale }) => {
  const dispatch = useAppDispatch();

  const changeHandler = useCallback(
    (scale: ResourceExplorerChartScale) => {
      dispatch(setResourceExplorerChartBase("cost"));
      dispatch(updateBillingExplorerChartSettingsThunk({ scale }));
    },
    [dispatch],
  );

  return <ChartScaleSelect scale={scale} onScaleChange={changeHandler} />;
};
